import { Typography } from '@mui/material';
import React from 'react';

const PrivacyPolicy: React.FC = () => {
    return (
        <>
            <Typography variant='h4' textAlign='center' mt={5}>Privacy Policy</Typography>
        </>
    );
};

export default PrivacyPolicy;
